module.exports = __webpack_public_path__ + "img/signIn.8077c954.svg";